<template>
  <info-modal @close-popup="closePopup">
    <template v-slot:title>
      <h3 class="title title--center failure__title">Failed transaction!</h3>
    </template>
    <template v-slot:icon>
      <img src="@/assets/icons/Failure.svg" alt="Error icon" />
    </template>

    <template v-slot:content>
      <div class="failure">
        <div class="failure__content">
          Your payment with <img :src="FailureLogo" alt="" class="failure__badge" /> was not successsful, please try again.
        </div>

        <div @click="retryPayment" class="failure__c-t-a btn btn__primary btn--lg">
          <button>Try Again</button>
        </div>
      </div>
    </template>
  </info-modal>
</template>

<script lang="ts" setup>
import FailureLogo from '@/assets/icons/FailureLogo.svg'
import InfoModal from '@/components/info-modal/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}

const retryPayment = () => {
  store.actions.setComponent('review-payment')
}
</script>
